import React from 'react';
import PropTypes from 'prop-types';
import _ from 'lodash';
import ShallowRenderedComponent from '../base/ShallowRenderedComponent';
import ReactTooltip from 'react-tooltip';

const requestTooltipRebuild = _.debounce(() => ReactTooltip.rebuild(), 300);

class Tooltip extends ShallowRenderedComponent {

	static propTypes = {
		tip: PropTypes.any,
		html: PropTypes.bool
	};

	static defaultProps = {
		html: false
	};

	constructor(props) {
		super(props);
	}

	componentDidMount() {
		super.componentDidMount();
		requestTooltipRebuild();
	}

	componentDidUpdate() {
		requestTooltipRebuild();
	}

	render() {
		const { children, tip, html, place, className, triggerClassName, delayShow } = this.props;
		if(_.isEmpty(tip)) {
			return children;
		}
		// className -> data-class: styles the tooltip popup (the floating bubble)
		// triggerClassName: styles the trigger element (the thing you hover),
		const tipProps = {
			['data-tip']: tip,
			['data-multiline']: !html,
			['data-for']: html ? 'html-tooltip' : 'default-tooltip',
			['data-place']: place ? place : 'top',
			['data-class']: className,
			...(delayShow != null && { ['data-delay-show']: delayShow })
		};
		// React element child: inject tipProps via cloneElement (no extra DOM node).
		// Merge triggerClassName so child keeps its own classes (e.g. 'material-symbols-outlined')
		// while also receiving triggerClassName (e.g. 'd-flex') when provided.
		if (React.isValidElement(children) && typeof children.type === 'string') {
			const mergedClassName = [children.props.className, triggerClassName].filter(Boolean).join(' ') || undefined;
			return React.cloneElement(children, { ...tipProps, className: mergedClassName });
		}
		// Non-element child (plain text, number, or multiple children): wrap in <span> since only elements can hold attributes
		return <span {...tipProps} className={triggerClassName}>{children}</span>;
	}
}

export default Tooltip;
